export const columnFields = [
	'id',
	'materialId',
	'sku',
	'name',

	'propertyTypes',
	'propertyTypeRefs',
	'propertyValues',

	'materialCategoryId',
	'categoryRef',

	'priceUnitId',
	'priceUnit',
	'priceUnitRef',

	'stockStatus',
	'stockStatusRef',

	'materialTemplateId',
	'materialTemplateRef',

	'createdAt',
	'updatedAt',
] as const;
